import { render, staticRenderFns } from "./InstallApp.vue?vue&type=template&id=cfe561d8&scoped=true&"
import script from "./InstallApp.vue?vue&type=script&lang=js&"
export * from "./InstallApp.vue?vue&type=script&lang=js&"
import style0 from "./InstallApp.vue?vue&type=style&index=0&id=cfe561d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe561d8",
  null
  
)

export default component.exports